import React from 'react'
// import { Link } from 'react-router-dom'
import { Modal, Form, Icon, Input, Button, notification } from 'antd'
import { parse, isValidNumber } from 'libphonenumber-js'

import InputPhone from 'components/InputPhone'
import imgLogo from 'assets/spiffme_600px.png'
import './styles.css'

const FormItem = Form.Item

const formItemLayout = {
  labelCol: {
    xs: { span: 1 }
  },
  wrapperCol: {
    xs: { span: 23 }
  },
  colon: false
}

class SignUp extends React.Component {
  state = {
    visible: true
  }

  onClose = () => {
    this.setState({ visible: false })
    setTimeout(() => this.props.changeRoute('/'), 300)
  }

  checkPassword = (rule, value, callback) => {
    const form = this.props.form
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!')
    } else {
      callback()
    }
  }

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true })
    }
    callback()
  }

  handleSubmit = e => {
    e.preventDefault()
    const { validateFields } = this.props.form

    validateFields((err, values) => {
      if (err) {
        notification['error']({
          message: 'Validation Error',
          description: 'Please enter correct information.',
          duration: 3
        })
      } else {
        const data = {
          ...values
        }
        // this.props.signUp(data)
        this.setState({ visible: false })
        this.props.onSubmit(data)
      }
    })
  }

  checkPhone = (rule, value, callback) => {
    const phone = this.props.form.getFieldValue('phone_number')

    if (phone && !isValidNumber(parse(phone))) {
      callback('Please input correct phone number!')
    } else {
      callback()
    }
  }

  render () {
    const { getFieldDecorator } = this.props.form
    const { data } = this.props

    return (
      <Modal
        wrapClassName='vertical-center-modal'
        visible={this.state.visible}
        footer={null}
        onCancel={this.onClose}
      >
        <div className='signup'>
          <img className='logo' src={imgLogo} alt='logo' />
          <p className='description'>
            We need the information below to
            <br /> create your account.
            <br />
            Fields marked with a <span style={{ color: '#f5222d' }}>*</span> are
            required.
          </p>

          <div className='form'>
            <Form onSubmit={this.handleSubmit}>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('custom:jobtitle', {
                  initialValue: data['custom:jobtitle']
                  // rules: [{ required: true, message: 'Please input your job title!' }],
                })(
                  <Input
                    prefix={<Icon type='user' />}
                    placeholder='Job Title'
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('given_name', {
                  initialValue: data['given_name'],
                  rules: [
                    {
                      required: true,
                      message: 'Please input your first name!'
                    }
                  ]
                })(
                  <Input
                    prefix={<Icon type='user' />}
                    placeholder='First Name'
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('family_name', {
                  initialValue: data['family_name'],
                  rules: [
                    { required: true, message: 'Please input your last name!' }
                  ]
                })(
                  <Input
                    prefix={<Icon type='user' />}
                    placeholder='Last Name'
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('email', {
                  initialValue: data['email'],
                  rules: [
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!'
                    },
                    {
                      required: true,
                      message: 'Please input your E-mail!'
                    }
                  ]
                })(
                  <Input prefix={<Icon type='mail' />} placeholder='E-mail' />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('phone_number', {
                  initialValue: data['phone_number'],
                  rules: [
                    {
                      required: true,
                      message: 'Please input phone number.'
                    },
                    {
                      validator: this.checkPhone
                    }
                  ]
                })(<InputPhone placeholder='Phone Number' />)}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('password', {
                  initialValue: data['password'],
                  rules: [
                    {
                      required: true,
                      message: 'Please input your password!'
                    },
                    {
                      pattern: /^(?=.*[A-Z])^(?=.*[\d])^(?=.*[a-z])(.){8,}/,
                      message:
                        'Minimum 8 characters, at least one uppercase, lowercase, and number.'
                    },
                    {
                      validator: this.checkConfirm
                    }
                  ]
                })(
                  <Input
                    prefix={<Icon type='lock' />}
                    type='password'
                    placeholder='Password'
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                {getFieldDecorator('confirm', {
                  initialValue: data['confirm'],
                  rules: [
                    {
                      required: true,
                      message: 'Please confirm your password!'
                    },
                    {
                      validator: this.checkPassword
                    }
                  ]
                })(
                  <Input
                    prefix={<Icon type='lock' />}
                    type='password'
                    placeholder='Confirm Password'
                  />
                )}
              </FormItem>
              <FormItem {...formItemLayout} label=' '>
                <Button
                  size='large'
                  ghost
                  htmlType='submit'
                  className='form-button'
                >
                  Next
                </Button>
                <div style={{ textAlign: 'center' }}>
                  {/* <Link to="/user/signin">Already signed up? Sign in now!</Link> */}
                </div>
              </FormItem>
            </Form>
          </div>
        </div>
      </Modal>
    )
  }
}

export default Form.create()(SignUp)
